var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"footerCopy"},[_c('span',[_vm._v("Copyright © "+_vm._s((new Date()).getFullYear())+" 臭豆腐電影")]),_c('router-link',{attrs:{"to":"/privacypolicy"}},[_vm._v("Privacy Policy")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }